import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TeamComponent } from './team/team.component';
import { HomeComponent } from './home/home.component';
import { HealthComponent } from './health/health.component';
import { CultureComponent } from './culture/culture.component';
import { ComplainRegisterComponent } from './complain-register/complain-register.component';
import { ComplainStatusComponent } from './complain-status/complain-status.component';
import { AboutComponent } from './about/about.component';
import { GalleryComponent } from './gallery/gallery.component';
import { LoginComponent } from './login/login.component';
import { SchemesComponent } from './schemes/schemes.component';
const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'Team', component: TeamComponent },
  { path: 'Login', component: LoginComponent },
  { path: 'Home', component: HomeComponent },
  { path: 'Health', component: HealthComponent },
  { path: 'Complain-reg', component: ComplainRegisterComponent },
  { path: 'Complain-status', component: ComplainStatusComponent },
  { path: 'Culture', component: CultureComponent },
  { path: 'About', component: AboutComponent },
  { path: 'Gallery', component: GalleryComponent },
  { path: 'Schemes', component: SchemesComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
export const routingComponents = [HomeComponent];
